var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-sm-1 mt-0"},[_c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title fw-bold"},[_vm._v(_vm._s(_vm.$t('project.title')))])]),_c('ProjectForm',{attrs:{"editMode":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }